<template>
  <div class="footer-content">
    <div class="footer-left">
      <img src="@/assets/images/footer-logo.png" class="logo" />
      <div class="hr"></div>
      <div class="left-content">
        <el-select
          size="small"
          v-model="link"
          class="friendly-link"
          :placeholder="$t('footer.link')"
          @change="handleLink"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <div class="footer-copyright">
          <div>
            {{ $t("footer.copyright") }}
          </div>
          <div>
            <a
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33088102002129"
              target="_blank"
              >{{ $t("footer.recordFiling.mps") }}</a
            >
            <a href="https://beian.miit.gov.cn" target="_blank">{{
              $t("footer.recordFiling.icp")
            }}</a>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-right">
      <img class="qrcode" src="@/assets/images/qrcode-1.png" />
      <img class="qrcode" src="@/assets/images/qrcode-2.png" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      link: "",
      // options: [
      //   {
      //     label: "江山旅发官网",
      //     value: "http://www.zjjslf.com/",
      //   },
      //   {
      //     label: "江山信息网",
      //     value: "http://www.21js.com/",
      //   },
      //   {
      //     label: "江山政府网",
      //     value: "http://www.jiangshan.gov.cn/",
      //   },
      //   {
      //     label: "江山新闻网",
      //     value: "http://jsnews.zjol.com.cn/",
      //   },
      //   {
      //     label: "江山旅游网",
      //     value: "http://ct.zj.gov.cn/",
      //   },
      // ],
    };
  },
  computed: {
    options() {
      return this.$t("footer.linkList");
      // [
      //   {
      //     label: "江山旅发官网",
      //     value: "http://www.zjjslf.com/",
      //   },
      //   {
      //     label: "江山信息网",
      //     value: "http://www.21js.com/",
      //   },
      //   {
      //     label: "江山政府网",
      //     value: "http://www.jiangshan.gov.cn/",
      //   },
      //   {
      //     label: "江山新闻网",
      //     value: "http://jsnews.zjol.com.cn/",
      //   },
      //   {
      //     label: "江山旅游网",
      //     value: "http://ct.zj.gov.cn/",
      //   },
      // ];
    },
  },
  methods: {
    handleLink(value) {
      this.link = "";
      window.open(value);
    },
  },
};
</script>

<style lang="scss" scoped>
.footer-content {
  padding: 18px 8.3%;
  background: #171f1e;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .footer-left,
  .footer-right {
    display: flex;
    align-items: center;
    height: 100%;
  }
  .logo {
    width: 125px;
  }
  .hr {
    height: 100%;
    width: 1px;
    background: rgba(255, 255, 255, 0.2);
    margin: 0 40px;
  }
  .left-content {
    .friendly-link {
      ::v-deep {
        .el-input__inner {
          border: none;
          border-radius: 0;
          background-color: #282c2b;
        }
      }
    }
    .footer-copyright {
      margin-top: 12px;
      color: #e1ebf2;
      font-size: 13px;
      font-weight: 400;
      line-height: 26px; /* 200% */
      a {
        color: #e1ebf2;
        text-decoration: none;
        margin-right: 10px;
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
  .footer-right {
    display: flex;
    .qrcode {
      width: 104px;
      display: block;
      + .qrcode {
        margin-left: 16px;
      }
    }
  }
}
</style>
